/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для дополнительного телефона в кабинете
   */
  app.UserPhoneView = app.View.extend({
    
    tagName: 'dd',
    
    removed: false,
    
    events: {
      'click .remove-phone': 'removeView'
    },

    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#user-phone-view-template');
    },
    
    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    },
    
    save: function () {
      this.model.save(
        {
          value: this.$el.find('.input_4').val()
        },
        {
          'success': this.success.bind(this),
          'error': this.error.bind(this),
          'wait': true
        }
      );
    },
    
    success: function () {
      this.removeError();
      this.trigger('success-user-phone-view');
    },
    
    error: function (model, response) {
      var that = this,
        errors = JSON.parse(response.responseText);
      
      this.removeError();
      
      try {
        errors.forEach(function (error) {
          that.$el.find('#user-phone-' + error.field + '-error').text(error.message);
          that.$el.find('#user-phone-' + error.field).addClass('error');
        });
      } catch (err) {
        err.message = 'forEach is not a function when "responseText" is ' + response.responseText;
        if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
          Raven.captureException(err);
        } else {
          throw err;
        }
      }
      
      this.trigger('error-user-phone-view');
    },
    
    removeError: function () {
      this.$el.find('.input_4').removeClass('error');
      this.$el.find('.error-message').text('');
    },
    
    
    /**
     * Удаляет поле для ввода телефона
     */
    removeView: function () {
      this.remove();
      this.removed = true;
    },
    
    /**
     * Удаляет модель телефона
     */
    removeModel: function () {
      this.model.destroy();
      this.trigger('remove-user-phone-view');
    }
  });
})(jQuery);

}.call(window));